export default "__VITE_ASSET__j_JhGLyA__"